import React, { useState } from 'react';
import { useUa } from './UserAdminContext';
import Icon from './UaIcon';
import PageHeader from './UaHeader';
import { Changes } from './UaBits';
import { RANGES, TYPE_FILTERS, activityFiltered, activitySheet, actorLabel, fmtTime, labelOf, ms, personById, plural, targetLabel, whenDay } from './uaModel';

const PAGE = 200;

/** Activity log: every change to a user or role, who made it, when, and what changed. */
export default function ActivityTab() {
    const { data, actFilters: af, setActFilters, actions, openPanel } = useUa();
    const [limit, setLimit] = useState(PAGE);
    const list = activityFiltered(data, af);
    const setA = (patch) => { setActFilters((old) => ({ ...old, ...patch })); setLimit(PAGE); };

    return (
        <>
            <PageHeader
                tab="activity" title="Activity log"
                sub="Every change to a user or role: who made it, when, and what changed."
                actions={(
                    <button type="button" className="ua-btn" onClick={() => actions.exportSheet(activitySheet(list, data), 'activity', 'change')}>
                        <Icon name="sheet" />Export to Excel
                    </button>
                )}
            />
            <section className="ua-card">
                <div className="ua-toolbar">
                    <label className="ua-search">
                        <span className="ua-sr">Search the log</span>
                        <Icon name="search" />
                        <input className="ua-inp" type="search" placeholder="Search by user" value={af.q} autoComplete="off" onChange={(e) => setA({ q: e.target.value })} />
                    </label>
                    <select className={`ua-sel${af.type !== 'all' ? ' ua-on' : ''}`} aria-label="Kind of change" value={af.type} onChange={(e) => setA({ type: e.target.value })}>
                        {TYPE_FILTERS.map((t) => <option key={t[0]} value={t[0]}>{t[1]}</option>)}
                    </select>
                    <select className="ua-sel" aria-label="Date range" value={af.range} onChange={(e) => setA({ range: e.target.value })}>
                        {RANGES.map((r) => <option key={r[0]} value={r[0]}>{r[1]}</option>)}
                    </select>
                    <span className="ua-end">{plural(list.length, 'change')}</span>
                </div>
                {!list.length ? (
                    <div className="ua-empty"><b>No changes match</b><span>Try a longer date range or another kind of change.</span></div>
                ) : (
                    <>
                        <div className="ua-tw">
                            <table className="ua-t">
                                <thead><tr><th>When</th><th>Changed by</th><th>User or role</th><th>Change</th><th>Details</th></tr></thead>
                                <tbody>
                                    {list.slice(0, limit).map((e) => {
                                        const t = ms(e.at);
                                        const person = personById(data, e.target);
                                        return (
                                            <tr key={e.id}>
                                                <td className="ua-when">{whenDay(t)}<small>{fmtTime(t)}</small></td>
                                                <td className="ua-nw">{actorLabel(e, data)}</td>
                                                <td className="ua-nw">
                                                    {person ? <button type="button" className="ua-name" onClick={() => openPanel(person.id)}>{targetLabel(e, data)}</button> : targetLabel(e, data)}
                                                </td>
                                                <td className="ua-nw">{labelOf(e.type)}</td>
                                                <td>{e.changes.length || e.note ? <Changes entry={e} /> : <span className="ua-muted">—</span>}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        {list.length > limit ? (
                            <div className="ua-tfoot">
                                <span>Showing {limit} of {list.length}</span>
                                <button type="button" className="ua-link" onClick={() => setLimit((n) => n + PAGE)}>Show {Math.min(PAGE, list.length - limit)} more</button>
                            </div>
                        ) : null}
                    </>
                )}
            </section>
        </>
    );
}
